export default {
  text: 'The site management system and library module were developed by BIMLIB with the support of the Skolkovo Foundation'
}
